"use client";

import { Arrow24 } from "@/components/icons";
import { IconButton } from "@/components/ui/iconButton";
import { Text } from "@/components/ui/Text";
import { clsx } from "@frend-digital/ui";
import Image from "next/image";
import styles from "./index.module.css";
import { useStickyProductStore } from "./store";

export interface StickyProductProps {
	image: string;
	title: string;
	price: string;
	variant: string;
}

export const StickyProduct = ({ image, title, price, variant }: StickyProductProps) => {
	const { show } = useStickyProductStore();
	return (
		<aside
			onClick={() =>
				window.scrollTo({
					top: 0,
					behavior: "smooth",
				})
			}
			className={clsx(styles.root, show && styles.show)}>
			<Image height={73} width={58} alt="" src={image} />
			<div className={styles.text}>
				<Text variant="h5" bold>
					{title}
				</Text>
				<Text variant="utility4">{variant}</Text>
				<Text variant="body2">{price}</Text>
			</div>

			<IconButton className={styles.toTopButton} color="white" size="large">
				<Arrow24 style={{ transform: "rotate(-90deg)" }} />
			</IconButton>
		</aside>
	);
};
